// Маршруты owner web ai.zafrm.pro (alias aiteam.zafrm.pro) — 13 путей из handoff `01-подход-и-каркас.md §3`.
//
// Реализованы как `<Routes>` без вложенных layout-routes: внешний AppShell живёт
// в `App.tsx` и обрамляет всё одинаково; страницы рендерятся как контент.
//
// Заметки:
//   - `/projects/:id` и `/vaults/:id` используют splat (`/*`), потому что id у
//     проекта/файла может содержать `/` (например, `frm.ai/ai.agents`, путь к md
//     внутри vault). Доступ через `useParams()['*']` в `*DetailPage`.
//   - 404 fallback (`*`) рендерит EmptyState без падения навигации; back-кнопка
//     браузера работает за счёт History API.

import { Route, Routes } from 'react-router'
import { AgentsPage } from '../pages/AgentsPage'
import { AgentDetailPage } from '../pages/AgentDetailPage'
import { ChatPage } from '../pages/ChatPage'
import { ChatWithAgentPage } from '../pages/ChatWithAgentPage'
import { HelpPage } from '../pages/HelpPage'
import { ProjectsPage } from '../pages/ProjectsPage'
import { ProjectDetailPage } from '../pages/ProjectDetailPage'
import { ReleasesPage } from '../pages/ReleasesPage'
import { SessionsPage } from '../pages/SessionsPage'
import { SkillsPage } from '../pages/SkillsPage'
import { VaultsPage } from '../pages/VaultsPage'
import { VaultDetailPage } from '../pages/VaultDetailPage'
import { PagePlaceholder } from '../shared/PagePlaceholder'

export function AppRoutes() {
  return (
    <Routes>
      {/* Агенты — корневой маршрут handoff'а */}
      <Route path="/" element={<AgentsPage />} />
      <Route path="/agents/:id" element={<AgentDetailPage />} />

      {/* Скилы (табы common/roles/project — внутри SkillsPage) */}
      <Route path="/skills" element={<SkillsPage />} />

      {/* Проекты: list + карточка по splat-пути (id может содержать `/`) */}
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/*" element={<ProjectDetailPage />} />

      {/* Сессии */}
      <Route path="/sessions" element={<SessionsPage />} />

      {/* Релизы */}
      <Route path="/releases" element={<ReleasesPage />} />

      {/* Чат: default + с конкретным агентом */}
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/chat/:agentId" element={<ChatWithAgentPage />} />

      {/* Хранилища: list + браузер дерева/файла по splat-пути */}
      <Route path="/vaults" element={<VaultsPage />} />
      <Route path="/vaults/*" element={<VaultDetailPage />} />

      {/* Справка */}
      <Route path="/help" element={<HelpPage />} />

      {/* 404 — не уводит из shell, показывает понятный fallback */}
      <Route
        path="*"
        element={
          <PagePlaceholder
            title="Маршрут не найден"
            description="Проверь URL или вернись на главную через топбар. Полный список маршрутов — в handoff `01-подход-и-каркас.md §3`."
          />
        }
      />
    </Routes>
  )
}
